// src/views/AnalyticsDashboard/TrackableRoute.js

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import trackAccess from './trackAccess';

const TrackableRoute = ({ moduleId, moduleName, children }) => {
	const userId = useSelector(state => state.session.user.id);

	useEffect(() => {
		if (userId && moduleId) {
			trackAccess(moduleId, moduleName, userId);
		}
	}, []);

	return children;
};

export default TrackableRoute;